import { useMutation } from '@tanstack/react-query';
import { Button } from '../../components/Button';
import { Dialog } from '../../components/Dialog';
import { ErrorNotice } from '../../components/States';
import { useToast } from '../../components/Toast';
import { blockUser } from '../../lib/api';
import { useRefreshBoards } from '../feed/queries';
import styles from './Safety.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  userId: string;
  name: string;
  onBlocked?: () => void;
}

export function BlockDialog({ open, onClose, userId, name, onBlocked }: Props) {
  const toast = useToast();
  const refresh = useRefreshBoards();
  const block = useMutation({
    mutationFn: () => blockUser(userId),
    onSuccess: async () => {
      toast.show(`Blocked ${name}`);
      onClose();
      onBlocked?.();
      await refresh();
    },
  });

  return (
    <Dialog open={open} onClose={onClose} title={`Block ${name}?`}>
      <p>
        You won't see each other's notes or replies, and {name} won't be able to see your profile. They aren't told that
        you blocked them.
      </p>
      <p className={styles.fine}>You can unblock people any time from your Me page.</p>
      {block.error && <ErrorNotice error={block.error} />}
      <div className={styles.actions}>
        <Button variant="quiet" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={() => block.mutate()} disabled={block.isPending}>
          Block {name}
        </Button>
      </div>
    </Dialog>
  );
}
